<section>
  <div class="row pt-4" style="margin: 0">
    <div class="filter" style="margin-left: 10%">
      <mat-form-field class="w-100">
        <input
          matInput
          type="text"
          [placeholder]="'document_template.lbl_filter_name' | translate"
          name="name"
          [(ngModel)]="filter.name"
          maxlength="200"
          autocomplete="off"
          (input)="filterData()"
          (keydown.enter)="$event.preventDefault()"
          [readonly]="notPermission"
        />
        <button
          mat-button
          type="button"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          *ngIf="filter.name"
          (click)="clearData(filter.name)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="filter">
      <mat-form-field class="w-100">
        <input
          matInput
          type="text"
          [placeholder]="'document_template.lbl_filter_merge_field' | translate"
          name="merge_field"
          [(ngModel)]="filter.merge_field"
          maxlength="200"
          autocomplete="off"
          (input)="filterData()"
          (keydown.enter)="$event.preventDefault()"
          [readonly]="notPermission"
        />
        <button
          mat-button
          type="button"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          *ngIf="filter.merge_field"
          (click)="clearData(filter.merge_field)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="text-right" style="position: relative; width: 50%">
      <div
        class="d-flex justify-content-end top-div-button"
        *ngIf="!notPermission"
      >
        <button
          mat-stroked-button
          color="primary"
          class="mr-2 custom-button-icon"
          type="button"
          (click)="onOpenDialogFieldConfig()"
          [matTooltip]="'button.create_field' | translate"
        >
          <mat-icon class="mr-0">add_circle</mat-icon>
          <!-- {{ "button.create_field" | translate }} -->
        </button>
        <button
          mat-stroked-button
          color="primary"
          class="mr-2 custom-button-icon"
          id="btn_del"
          type="button"
          (click)="deleteFieldConfigs()"
          [disabled]="!dataRowsNeedChange.length"
          [matTooltip]="'button.delete' | translate"
        >
          <i class="fa fa-trash" style="font-size: 20px" aria-hidden="true"></i>
          <!-- {{ "button.difference_process" | translate }} -->
        </button>
        <button
          mat-stroked-button
          color="primary"
          class="mr-2 custom-button-icon"
          id="btn_del"
          type="button"
          (click)="openGroupDialog()"
          [disabled]="!dataRowsNeedChange.length"
          [matTooltip]="'button.group' | translate"
        >
          <i
            class="fa fa-list-ol"
            style="font-size: 20px"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 table_box">
      <mat-table
        [dataSource]="dataSource"
        cdkDropList
        [cdkDropListData]="dataSource"
        (cdkDropListDropped)="dropTable($event)"
        [cdkDropListDisabled]="
          filter.name || filter.mergeField || isAllowDragDrop()
        "
        #table
        id="table-box"
      >
        <!-- checkked Columns -->
        <ng-container matColumnDef="checked">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            ><mat-checkbox
              color="primary"
              class="isCheckAll"
              [checked]="checkBoxList.length === dataSource.length"
              [indeterminate]="
                checkBoxList.length && checkBoxList.length < dataSource.length
              "
              (change)="clickAll($event)"
              [disabled]="notPermission"
            ></mat-checkbox>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let index = index"
            (click)="$event.stopPropagation()"
            class="mat-cell-non-boder-right-bottom"
          >
            <mat-checkbox
              color="primary"
              class="check_box"
              [checked]="isChecked(element.fieldConfigId)"
              (change)="toggle($event, element)"
            ></mat-checkbox>
          </mat-cell>
        </ng-container>
        <!-- stt tren bang Columns -->
        <ng-container matColumnDef="rowIndex">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.row_index" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            (click)="$event.stopPropagation()"
            class="mat-cell-non-boder-right-bottom bg-gray"
          >
            {{ element.rowIndex }}
            <!-- {{ element?.orderNo }} -->
          </mat-cell>
        </ng-container>
        <!-- stt Columns -->
        <ng-container matColumnDef="index">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.stt" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            (click)="$event.stopPropagation()"
            class="mat-cell-non-boder-right-bottom"
          >
            {{ element.orderNo }}
            <!-- {{ element?.orderNo }} -->
          </mat-cell>
        </ng-container>
        <!-- name Columns -->
        <ng-container matColumnDef="name">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.name_field" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let i = index"
            class="mat-cell-non-boder-right-bottom cell"
            [matTooltip]="displayTooltip(element?.name, i, 'nameField')"
            [id]="'col-name-' + i"
          >
            <button
              *ngIf="element?.group"
              mat-icon-button
              color="primary"
              [matTooltip]="
                !element.close
                  ? ('enterprise_document_template.tooltips.btn_expand_more'
                    | translate)
                  : ('enterprise_document_template.tooltips.btn_expand_less'
                    | translate)
              "
              type="button"
            >
              <mat-icon id="expand_more" mat #expand_more *ngIf="!element.close"
                >add</mat-icon
              >
              <mat-icon id="expand_less" #expand_less *ngIf="element.close"
                >remove</mat-icon
              >
            </button>
            <span *ngIf="!element.group" class="tab"></span>
            <span
              [ngClass]="{ isGroup: element.group }"
              class="fix-width nameField"
              >{{ element?.name }}</span
            >
          </mat-cell>
        </ng-container>
        <!-- mergeField Columns -->
        <ng-container
          matColumnDef="mergeField"
          class="mat-cell-non-boder-right-bottom"
        >
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.merge_field" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let i = index"
            (click)="$event.stopPropagation()"
            [matTooltip]="displayTooltip(element?.mergeField, i, 'mergeField')"
            class="mat-cell-non-boder-right-bottom"
          >
            <span class="fix-width mergeField">{{ element?.mergeField }}</span>
          </mat-cell>
        </ng-container>
        <!-- fieldType Columns -->
        <ng-container
          matColumnDef="fieldType"
          class="mat-cell-non-boder-right-bottom"
        >
          <mat-header-cell *matHeaderCellDef
            >{{ "headertable.field_type" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            (click)="$event.stopPropagation()"
            class="mat-cell-non-boder-right-bottom"
          >
            {{ element?.dataType?.name }}
          </mat-cell>
        </ng-container>
        <!-- required Columns -->
        <ng-container
          matColumnDef="required"
          class="mat-cell-non-boder-right-bottom"
        >
          <mat-header-cell *matHeaderCellDef>
            {{ "headertable.required" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            (click)="$event.stopPropagation()"
            class="mat-cell-non-boder-right-bottom"
          >
            <span
              class="material-icons color-primary"
              *ngIf="checkRequiredData(element)"
            >
              check
            </span>
          </mat-cell>
        </ng-container>
        <!-- hide Columns -->
        <ng-container matColumnDef="hide">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.hide" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            (click)="$event.stopPropagation()"
            class="mat-cell-non-boder-right-bottom"
          >
            <span class="material-icons color-primary" *ngIf="element?.hide">
              check
            </span>
          </mat-cell>
        </ng-container>
        <!-- action Columns -->
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef
            >{{ "headertable.action_header" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            class="text-center"
            (click)="$event.stopPropagation()"
          >
            <button
              mat-icon-button
              (click)="onOpenDialogFieldConfig(element)"
              color="primary"
              type="button"
            >
              <mat-icon
                matTooltip="{{ 'document_template.tooltip_edit' | translate }}"
                >mode_edit</mat-icon
              >
            </button>
            <button
              type="button"
              mat-icon-button
              (click)="copyFieldConfig($event, element)"
            >
              <mat-icon
                matTooltip="{{
                  'enterprise_contract.buttons.copy' | translate
                }}"
                >file_copy</mat-icon
              >
            </button>
            <button
              mat-icon-button
              color="primary"
              (click)="deleteTemplateFieldConfig(element)"
              type="button"
            >
              <i
                class="fa fa-trash"
                style="font-size: 20px"
                aria-hidden="true"
                matTooltip="{{
                  'document_template.tooltip_delete' | translate
                }}"
              ></i>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; let i = index; columns: displayedColumns"
          matRipple
          class="element-row"
          [cdkDetailRow]="row"
          [cdkDetailRowTpl]="tpl"
          (toggleChange)="onToggleChange($event, row)"
          cdkDrag
          (cdkDragStarted)="dragStarted($event, i)"
          (cdkDragEnded)="dragEnded()"
          cdkDragLockAxis="y"
          cdkDragBoundary=".table_box"
        >
          <!-- preview data -->
          <div *cdkDragPreview [ngStyle]="{ 'width.px': widthTable }">
            <mat-table [dataSource]="dataDragPreview">
              <ng-container matColumnDef="checked">
                <mat-cell
                  *matCellDef="let element; let index = index"
                  class="mat-cell-non-boder-right-bottom"
                >
                  <mat-checkbox
                    color="primary"
                    class="check_box"
                    [checked]="isChecked(element.fieldConfigId)"
                  ></mat-checkbox>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="rowIndex">
                <mat-cell
                  *matCellDef="let element"
                  (click)="$event.stopPropagation()"
                  class="mat-cell-non-boder-right-bottom"
                >
                  {{ element.rowIndex }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="index">
                <mat-cell
                  *matCellDef="let element"
                  (click)="$event.stopPropagation()"
                  class="mat-cell-non-boder-right-bottom"
                >
                  {{ element.orderNo }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="name">
                <mat-cell
                  *matCellDef="let element; let i = index"
                  class="mat-cell-non-boder-right-bottom cell"
                  [matTooltip]="displayTooltip(element?.name, i, 'nameField')"
                >
                  <button
                    *ngIf="element?.group"
                    mat-icon-button
                    color="primary"
                    [matTooltip]="
                      !element.close
                        ? ('enterprise_document_template.tooltips.btn_expand_more'
                          | translate)
                        : ('enterprise_document_template.tooltips.btn_expand_less'
                          | translate)
                    "
                    type="button"
                  >
                    <mat-icon
                      id="expand_more"
                      mat
                      #expand_more
                      *ngIf="!element.close"
                      >add</mat-icon
                    >
                    <mat-icon
                      id="expand_less"
                      #expand_less
                      *ngIf="element.close"
                      >remove</mat-icon
                    >
                  </button>
                  <span *ngIf="!element.group" class="tab"></span>
                  <span
                    [ngClass]="{ isGroup: element.group }"
                    class="fix-width nameField"
                    >{{ element?.name }}</span
                  >
                </mat-cell>
              </ng-container>
              <ng-container
                matColumnDef="mergeField"
                class="mat-cell-non-boder-right-bottom"
              >
                <mat-cell
                  *matCellDef="let element; let i = index"
                  (click)="$event.stopPropagation()"
                  [matTooltip]="
                    displayTooltip(element?.mergeField, i, 'mergeField')
                  "
                  class="mat-cell-non-boder-right-bottom"
                >
                  <span class="fix-width mergeField">{{
                    element?.mergeField
                  }}</span>
                </mat-cell>
              </ng-container>
              <ng-container
                matColumnDef="fieldType"
                class="mat-cell-non-boder-right-bottom"
              >
                <mat-cell
                  *matCellDef="let element"
                  (click)="$event.stopPropagation()"
                  class="mat-cell-non-boder-right-bottom"
                >
                  {{ element?.dataType?.name }}
                </mat-cell>
              </ng-container>
              <ng-container
                matColumnDef="required"
                class="mat-cell-non-boder-right-bottom"
              >
                <mat-cell
                  *matCellDef="let element"
                  (click)="$event.stopPropagation()"
                  class="mat-cell-non-boder-right-bottom"
                >
                  <span
                    class="material-icons color-primary"
                    *ngIf="checkRequiredData(element)"
                  >
                    check
                  </span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="hide">
                <mat-cell
                  *matCellDef="let element"
                  (click)="$event.stopPropagation()"
                  class="mat-cell-non-boder-right-bottom"
                >
                  <span
                    class="material-icons color-primary"
                    *ngIf="element?.hide"
                  >
                    check
                  </span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="action">
                <mat-cell
                  *matCellDef="let element"
                  class="text-center"
                  (click)="$event.stopPropagation()"
                >
                  <button
                    mat-icon-button
                    (click)="onOpenDialogFieldConfig(element)"
                    color="primary"
                    type="button"
                  >
                    <mat-icon
                      matTooltip="{{
                        'document_template.tooltip_edit' | translate
                      }}"
                      >mode_edit</mat-icon
                    >
                  </button>
                  <button
                    type="button"
                    mat-icon-button
                    (click)="copyFieldConfig($event, element)"
                  >
                    <mat-icon
                      matTooltip="{{
                        'enterprise_contract.buttons.copy' | translate
                      }}"
                      >file_copy</mat-icon
                    >
                  </button>
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="deleteTemplateFieldConfig(element)"
                    type="button"
                  >
                    <i
                      class="fa fa-trash"
                      style="font-size: 20px"
                      aria-hidden="true"
                      matTooltip="{{
                        'document_template.tooltip_delete' | translate
                      }}"
                    ></i>
                  </button>
                </mat-cell>
              </ng-container>
              <mat-row
                *matRowDef="let row; let i = index; columns: displayedColumns"
              >
              </mat-row>
            </mat-table>
          </div>
        </mat-row>

        <ng-template #tpl let-element>
          <div
            class="mat-row detail-row"
            [@detailExpand]="true"
            style="overflow: hidden"
          >
            <!-- add child table here !!! -->

            <mat-table
              [dataSource]="element.children"
              class="child-left"
              cdkDropList
              [cdkDropListData]="element.children"
              (cdkDropListDropped)="
                dropTableChild($event, element.fieldConfigId)
              "
              [cdkDropListDisabled]="
                filter.name || filter.mergeField || isAllowDragDropChild()
              "
            >
              <!-- checkked Columns -->
              <ng-container matColumnDef="checked">
                <mat-cell
                  *matCellDef="let elementChild"
                  class="mat-cell-non-boder-right-bottom"
                >
                  <mat-checkbox
                    color="primary"
                    class="check_box"
                    [checked]="isChecked(elementChild.fieldConfigId)"
                    (change)="toggle($event, element, elementChild)"
                  ></mat-checkbox>
                </mat-cell>
              </ng-container>
              <!-- stt tren bang Columns -->
              <ng-container matColumnDef="rowIndex">
                <mat-cell
                  *matCellDef="let elementChild"
                  class="mat-cell-non-boder-right-bottom"
                >
                  {{ elementChild?.rowIndex }}
                </mat-cell>
              </ng-container>
              <!-- stt Columns -->
              <ng-container matColumnDef="index">
                <mat-cell
                  *matCellDef="let elementChild"
                  class="mat-cell-non-boder-right-bottom"
                >
                  {{ element?.orderNo }}.{{ elementChild?.orderNo }}
                </mat-cell>
              </ng-container>
              <!-- name Columns -->
              <ng-container matColumnDef="name">
                <mat-cell
                  *matCellDef="let elementChild"
                  class="mat-cell-non-boder-right-bottom"
                >
                  <span class="child">
                    <mat-icon id="expand_more" mat
                      >subdirectory_arrow_right</mat-icon
                    >
                  </span>
                  {{ elementChild?.name }}
                </mat-cell>
              </ng-container>
              <!-- mergeField Columns -->
              <ng-container matColumnDef="mergeField">
                <mat-cell
                  *matCellDef="let elementChild"
                  class="mat-cell-non-boder-right-bottom"
                >
                  {{ elementChild?.mergeField }}
                </mat-cell>
              </ng-container>
              <!-- fieldType Columns -->
              <ng-container matColumnDef="fieldType">
                <mat-cell
                  *matCellDef="let elementChild"
                  class="mat-cell-non-boder-right-bottom"
                >
                  {{ elementChild?.dataType?.name }}
                </mat-cell>
              </ng-container>
              <!-- required Columns -->
              <ng-container matColumnDef="required">
                <mat-cell
                  *matCellDef="let elementChild"
                  class="mat-cell-non-boder-right-bottom"
                >
                  <span
                    class="material-icons color-primary"
                    *ngIf="checkRequiredData(elementChild)"
                  >
                    check
                  </span>
                </mat-cell>
              </ng-container>
              <!-- hide Columns -->
              <ng-container matColumnDef="hide">
                <mat-cell
                  *matCellDef="let elementChild"
                  class="mat-cell-non-boder-right-bottom"
                >
                  <span
                    class="material-icons color-primary"
                    *ngIf="elementChild?.hide"
                  >
                    check
                  </span>
                </mat-cell>
              </ng-container>
              <!-- action Columns -->
              <ng-container matColumnDef="action">
                <mat-cell *matCellDef="let elementChild" class="text-center">
                  <button
                    mat-icon-button
                    (click)="onOpenDialogFieldConfig(elementChild)"
                    color="primary"
                    type="button"
                  >
                    <mat-icon
                      matTooltip="{{
                        'document_template.tooltip_edit' | translate
                      }}"
                      >mode_edit</mat-icon
                    >
                  </button>
                  <button mat-icon-button>
                    <mat-icon
                      type="button"
                      matTooltip="{{
                        'enterprise_contract.buttons.copy' | translate
                      }}"
                      (click)="
                        copyFieldConfigChild($event, element, elementChild)
                      "
                      >file_copy</mat-icon
                    >
                  </button>
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="deleteFieldConfid(elementChild, element)"
                    type="button"
                  >
                    <i
                      class="fa fa-trash"
                      style="font-size: 20px"
                      aria-hidden="true"
                      matTooltip="{{
                        'document_template.tooltip_delete' | translate
                      }}"
                    ></i>
                  </button>
                </mat-cell>
              </ng-container>
              <mat-row
                *matRowDef="
                  let rowChild;
                  let y = index;
                  columns: displayedColumns
                "
                cdkDrag
                [cdkDragData]="rowChild"
                cdkDragBoundary=".detail-row"
                (cdkDragStarted)="
                  dragStartedChild($event, y, element.fieldConfigId)
                "
                (cdkDragEnded)="dragEnded()"
              >
                <!-- preview data -->
                <div *cdkDragPreview [ngStyle]="{ 'width.px': widthTable }">
                  <mat-table [dataSource]="dataDragPreview">
                    <ng-container matColumnDef="checked">
                      <mat-cell
                        *matCellDef="let element; let index = index"
                        class="mat-cell-non-boder-right-bottom"
                      >
                        <mat-checkbox
                          color="primary"
                          class="check_box"
                          [checked]="isChecked(element.fieldConfigId)"
                        ></mat-checkbox>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="rowIndex">
                      <mat-cell
                        *matCellDef="let element"
                        class="mat-cell-non-boder-right-bottom"
                      >
                        {{ element.rowIndex }}
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="index">
                      <mat-cell
                        *matCellDef="let element"
                        (click)="$event.stopPropagation()"
                        class="mat-cell-non-boder-right-bottom"
                      >
                        {{ element.orderNo }}
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="name">
                      <mat-cell
                        *matCellDef="let element; let i = index"
                        class="mat-cell-non-boder-right-bottom cell"
                        [matTooltip]="
                          displayTooltip(element?.name, i, 'nameField')
                        "
                      >
                        <button
                          *ngIf="element?.group"
                          mat-icon-button
                          color="primary"
                          [matTooltip]="
                            !element.close
                              ? ('enterprise_document_template.tooltips.btn_expand_more'
                                | translate)
                              : ('enterprise_document_template.tooltips.btn_expand_less'
                                | translate)
                          "
                          type="button"
                        >
                          <mat-icon
                            id="expand_more"
                            mat
                            #expand_more
                            *ngIf="!element.close"
                            >add</mat-icon
                          >
                          <mat-icon
                            id="expand_less"
                            #expand_less
                            *ngIf="element.close"
                            >remove</mat-icon
                          >
                        </button>
                        <span *ngIf="!element.group" class="tab"></span>
                        <span
                          [ngClass]="{ isGroup: element.group }"
                          class="fix-width nameField"
                          >{{ element?.name }}</span
                        >
                      </mat-cell>
                    </ng-container>
                    <ng-container
                      matColumnDef="mergeField"
                      class="mat-cell-non-boder-right-bottom"
                    >
                      <mat-cell
                        *matCellDef="let element; let i = index"
                        (click)="$event.stopPropagation()"
                        [matTooltip]="
                          displayTooltip(element?.mergeField, i, 'mergeField')
                        "
                        class="mat-cell-non-boder-right-bottom"
                      >
                        <span class="fix-width mergeField">{{
                          element?.mergeField
                        }}</span>
                      </mat-cell>
                    </ng-container>
                    <ng-container
                      matColumnDef="fieldType"
                      class="mat-cell-non-boder-right-bottom"
                    >
                      <mat-cell
                        *matCellDef="let element"
                        (click)="$event.stopPropagation()"
                        class="mat-cell-non-boder-right-bottom"
                      >
                        {{ element?.dataType?.name }}
                      </mat-cell>
                    </ng-container>
                    <ng-container
                      matColumnDef="required"
                      class="mat-cell-non-boder-right-bottom"
                    >
                      <mat-cell
                        *matCellDef="let element"
                        (click)="$event.stopPropagation()"
                        class="mat-cell-non-boder-right-bottom"
                      >
                        <span
                          class="material-icons color-primary"
                          *ngIf="checkRequiredData(element)"
                        >
                          check
                        </span>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="hide">
                      <mat-cell
                        *matCellDef="let element"
                        (click)="$event.stopPropagation()"
                        class="mat-cell-non-boder-right-bottom"
                      >
                        <span
                          class="material-icons color-primary"
                          *ngIf="element?.hide"
                        >
                          check
                        </span>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="action">
                      <mat-cell
                        *matCellDef="let element"
                        class="text-center"
                        (click)="$event.stopPropagation()"
                      >
                        <button
                          mat-icon-button
                          (click)="onOpenDialogFieldConfig(element)"
                          color="primary"
                          type="button"
                        >
                          <mat-icon
                            matTooltip="{{
                              'document_template.tooltip_edit' | translate
                            }}"
                            >mode_edit</mat-icon
                          >
                        </button>
                        <button
                          type="button"
                          mat-icon-button
                          (click)="copyFieldConfig($event, element)"
                        >
                          <mat-icon
                            color="primary"
                            matTooltip="{{
                              'enterprise_contract.buttons.copy' | translate
                            }}"
                            >file_copy</mat-icon
                          >
                        </button>
                        <button
                          mat-icon-button
                          color="primary"
                          (click)="deleteTemplateFieldConfig(element)"
                          type="button"
                        >
                          <i
                            class="fa fa-trash"
                            style="font-size: 20px"
                            aria-hidden="true"
                            matTooltip="{{
                              'document_template.tooltip_delete' | translate
                            }}"
                          ></i>
                        </button>
                      </mat-cell>
                    </ng-container>
                    <mat-row
                      *matRowDef="
                        let row;
                        let i = index;
                        columns: displayedColumns
                      "
                    >
                    </mat-row>
                  </mat-table>
                </div>
              </mat-row>
            </mat-table>

            <!-- end child table here !!! -->
          </div>
        </ng-template>
      </mat-table>
      <div class="no-data" *ngIf="!dataSource.length">
        {{ "form.no_record" | translate }}
      </div>
    </div>
  </div>
</section>
